export const API_HOST = process.env.API_HOST || ''
export const MAILTO = '?subject=:subject&body=:body'

// export const URL_PDF_QA = 'api/qa/pdf/:short'
export const URL_ABOUT = '/team.json'
export const URL_ASSOCIATED_RESOURCE_ENTRY = 'associated-resource/:urn/qa-annotation'
export const URL_ASSOCIATED_RESOURCE_QUERY = 'associated-resource/query/:qualifier/:urn'
export const URL_ASSOCIATED_RESOURCE_UPSERT = 'associated-resource/upsert'
export const URL_CRYPTO_KEY_LIST = 'secure/keymgmt/api/keymgmt/serve/ceku'
export const URL_CRYPTO_KEY_ADD = 'secure/keymgmt/api/keymgmt/manage/ceku'
export const URL_CURRENT_AWARENESS = 'ca/api/browse/:fromDate/:toDate(/*searchPhrase)'
export const URL_DATA = 'doc/api/data/:id'
export const URL_DOCUMENT = 'doc/api/document(/:id)'
export const URL_FEEDBACK = 'api/service/feedback'
// this gets around the fact that we're usually under /secure - bit of a hack
export const URL_GUIDE = '../static/:fileName'
export const URL_SECURE_GUIDE = 'static/:fileName'
export const URL_GUIDES = 'static-content/api/folders'
export const URL_FEATURED_GUIDES = 'static-content/api/featured'
export const URL_LEGISLATION_ACT = 'api/leg/:act'
export const URL_LEGISLATION_ACTS = 'api/leg/list?complete=true'
export const URL_LEGISLATION_CHAPTER = 'api/service/legislation/chapter/:section/:chapter/:act(/:schedule)'
export const URL_LEGISLATION_PART = 'api/service/legislation/part/:part/:act(/:schedule)'
export const URL_LEGISLATION_REFERENCE = 'api/leg/:references'
export const URL_LEGISLATION_RELATED_QAS = 'api/service/legislation/referenceqa/:flavour/(schedule-:schedule-)(part-:part-)(section-:section)/1/100'
export const URL_LEGISLATION_SCHEDULE = 'api/service/legislation/schedule/:schedule/:act'
export const URL_LEGISLATION_SEARCH = 'api/service/legsearch' // '/:queryString/:init/:limit'
export const URL_LEGISLATION_SECTION = 'api/service/legislation/section/:section/:act(/:schedule)'
export const URL_LEGISLATION_TOC = 'api/service/legislation/toc/:act'
export const URL_LOGOUT = 'api/auth/logout'
export const URL_METADATA = 'doc/api/metadata(/:id)'
export const URL_METADATA_SEARCH = 'doc/api/metadata'
export const URL_PASSWORD_RESET = 'users-api/users/client-password-reset'
export const URL_PDF = 'api/pdfservice'
export const URL_PDF_CA = 'api/ca/pdf/:short'
export const URL_PDF_LEG = 'api/leg/pdf/:short'
export const URL_PDF_QA = 'api/qa/pdf/:short'
export const URL_PRINT = 'api/prettyprint(/:short)'
export const URL_QA_CONTENT = 'api/service/questions/:flavour/:sections'
export const URL_QA_INSTANTSEARCH = 'api/service/autocomplete/:flavour/:queryString/0/10'
export const URL_QA_QUESTIONS = 'api/service/questions/:flavour'
export const URL_QA_REFERENCES = 'api/service/listQuestions/:references'
export const URL_QA_SEARCH = 'api/service/search/:flavour' // '/:queryString/:init/:limit'
export const URL_QA_SECTIONS = 'api/service/sections/:flavour'
export const URL_SEARCH_HISTORY = 'api/service/search-history(/:length)'
export const URL_SHORTENER = 'shorty/api/resource(/:short)'
export const URL_TAKEOVER_CODE = 'takeover/code(/:versionId)'
export const URL_TAKEOVER_CODE_VERSIONS = 'takeover/codes'
export const URL_TAKEOVER_CODE_COPY = 'takeover/copy'
export const URL_TAKEOVER_CODE_PUBLISH = 'takeover/version'
export const URL_TAKEOVER_CODE_EDIT_TITLE = 'takeover/section'
export const URL_TAKEOVER_CODE_EDIT_PARAGRAPH = 'takeover/paragraph'
export const URL_TAKEOVER_CODE_DELETE_PARAGRAPH = 'takeover/paragraph/:paragraphId'
export const URL_TAKEOVER_CODE_CREATE_PARAGRAPH = 'takeover/paragraph'
export const URL_TAKEOVER_CODE_EDIT_PREFIX = 'takeover/textPrefix'
export const URL_TAKEOVER_CODE_DELETE_PREFIX = 'takeover/textPrefix/:textPrefixId'
export const URL_TAKEOVER_CODE_CREATE_PREFIX = 'takeover/textPrefix'
export const URL_TRACKING = 'api/service/tracking'
export const URL_USER = 'api/auth/current-user'
export const URL_USERS = 'associated-resource/users'
export const URL_USER_AUTH = 'api/auth/external-auth'
export const URL_WRAPPING_CRYPTO_KEY = 'secure/keymgmt/api/keymgmt/serve/ckek' // 'rsa.jwk'
export const URL_GENERATE_WRAPPING_KEY = 'secure/keymgmt/api/keymgmt/manage/ckek'

export const TAKEOVER_INTERNAL = 'TAKEOVER+CODE'
